<sdc-bo-page-header headerTitle="Dashboard" />

<div class="dashboard gs-fill">
  <sdc-card headerTitle="Transactions" class="chart-card">
    <div id="highcharts-container"></div>
  </sdc-card>

  <sdc-card headerTitle="Event summary" class="summary-card">
    @if (eventList.length && resolved.length) {
      <div class="event-finder">
        <ng-multiselect-dropdown
          [placeholder]="'Select Event'"
          [settings]="dropdownSettings"
          [(ngModel)]="selectedItems"
          [data]="eventList"
          (onSelect)="ondropdownSelect($event)">
        </ng-multiselect-dropdown>
        <sdc-button
          variant="secondary"
          (onClick)="search()"
          [attr.data-cy]="'dashboard-search-button'">
          <ng-icon name="lucideSearch" aria-hidden="true" />
          <span>Search</span>
        </sdc-button>
      </div>
      <div class="summary-list">
        @for (item of summaryNumbers; track item.code) {
          <div class="summary-item">
            <div class="summary-item-header">
              <span class="summary-item-desc">{{ item.description }}</span>
              <span class="summary-item-meta"
                >{{ item.code }} · {{ item.date | date }}</span
              >
            </div>
            <sdc-info-grid [items]="summaryItems(item)" [columns]="3" />
          </div>
        }
      </div>
    } @else {
      <p>No dashboard data available.</p>
    }
  </sdc-card>
</div>
